import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getLeads = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/leads?' + params.toString()); // Let the error bubble up
};

const getLeadById = async (id: number) => {
  return await apiClient.get(`/leads/${id}`); // Fetch car listing by ID
};

const createLead = async (leadData: any) => {
  return await apiClient.post('/leads', leadData); // Create a new car listing
};

const updateLead = async (id: number, leadData: any) => {
  return await apiClient.patch(`/leads/${id}`, leadData); // Update car listing by ID
};

const deleteLead = async (id: number) => {
  return await apiClient.delete(`/leads/${id}`); // Delete car listing by ID
};

const searchLeadsAndLeads = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/search-leads-and-leads?' + params.toString()); // Let the error bubble up
};

const exportCSV = async (params: string, body: any) => {
  return await apiClient.post(`/leads/export?${params}`, body, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
};

export default {
  getLeads,
  getLeadById,
  createLead,
  updateLead,
  deleteLead,
  searchLeadsAndLeads,
  exportCSV
};
